import PropTypes from 'prop-types'
import { PureComponent } from 'react'

import { cn } from '@repo/utils'

class Block extends PureComponent {
  render() {
    const { children, className, style } = this.props

    return (
      <div className={cn('Block bg-white border-b m-0 p-2 relative *:last:border-b-0', className)} style={style}>
        {children}
      </div>
    )
  }
}

Block.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
  style: PropTypes.object,
}

export default Block
